module.exports = __webpack_public_path__ + "img/61.e9993764.webp";